import React,{useContext, useEffect} from 'react';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import config from '../../../config';

function Page404() {
	const { setPageName } = useContext(AppAuthGlobalVariables);
	const navigate = useNavigate();

	useEffect(() => {
		setPageName?.('');
	},[])

	return (
		<div className='component-container dashboard'>
			<div className='component-card'>
				<p>This page does not exist.</p>
				<p>Go back to the Home.</p>

				<Button onClick={() => navigate(config.HOME_PAGE)} variant='contained'>Home</Button>
			</div>
		</div>
	)
}

export default Page404